import { useSelector } from "react-redux";

const useSelectBrand = () => {
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  return { brandId };
};

export default useSelectBrand;
